import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientSetupPage from "@/pages/client/ClientSetupPage";

export const Route = createFileRoute("/client/setup")({
  head: () => pageHead("Set Your Client Portal Password", "Create your AKIVA Client Portal password.", "/client/setup", true),
  component: ClientSetupPage,
});
